// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025

/* eslint-disable import/no-anonymous-default-export */
import FixedDepositActionTypes from './fixed-deposit.types';
import { docodeHexResponse } from '../../../_common/common.utils';
const INITIAL_STATE = {
	getFixedDepositDetailsResponse: null,
	getFixedDepositDetailsArr: [],
	addFixedDepositDetailsResponse: null,
	deleteFixedDepositDetailsResponse: null,
	fetchFixedDepositCollectionApproveDetailsResponse: null,
	fetchFixedDepositCollectionApproveEodDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START GET FIXED DEPOSIT DETAILS  ******************** */
		case FixedDepositActionTypes.GET_FIXED_DEPOSIT_DETAILS_SUCCESS:
			return {
				...state,
				getFixedDepositDetailsResponse: action.payload,
				getFixedDepositDetailsArr: docodeHexResponse(
					action.payload,
					'GetMemberFixedDepositKey',
				),
			};

		case FixedDepositActionTypes.GET_FIXED_DEPOSIT_DETAILS_FAILURE:
			return {
				...state,
				getFixedDepositDetailsResponse: action.payload,
				getFixedDepositDetailsArr: [],
			};

		case FixedDepositActionTypes.GET_FIXED_DEPOSIT_DETAILS_RESPONSE_CHANGED:
			return { ...state, getFixedDepositDetailsResponse: null };
		/** *********************  END GET FIXED DEPOSIT DETAILS  ******************** */

		/** *********************  START ADD FIXED DEPOSIT DETAILS  ******************** */
		case FixedDepositActionTypes.ADD_FIXED_DEPOSIT_DETAILS_SUCCESS:
			return {
				...state,
				addFixedDepositDetailsResponse: action.payload,
			};

		case FixedDepositActionTypes.ADD_FIXED_DEPOSIT_DETAILS_FAILURE:
			return {
				...state,
				addFixedDepositDetailsResponse: action.payload,
			};

		case FixedDepositActionTypes.ADD_FIXED_DEPOSIT_DETAILS_RESPONSE_CHANGED:
			return { ...state, addFixedDepositDetailsResponse: null };
		/** *********************  END ADD FIXED DEPOSIT DETAILS  ******************** */

		/** *********************  START DELETE FIXED DEPOSIT DETAILS  ******************** */
		case FixedDepositActionTypes.DELETE_FIXED_DEPOSIT_DETAILS_SUCCESS:
			return {
				...state,
				deleteFixedDepositDetailsResponse: action.payload,
			};

		case FixedDepositActionTypes.DELETE_FIXED_DEPOSIT_DETAILS_FAILURE:
			return { ...state, deleteFixedDepositDetailsResponse: action.payload };

		case FixedDepositActionTypes.DELETE_FIXED_DEPOSIT_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteFixedDepositDetailsResponse: null };
		/** *********************  END DELETE FIXED DEPOSIT DETAILS  ******************** */

		/** *********************  START FETCH FIXED DEPOSIT COLLCTION APPROVE DETAILS  ******************** */
		case FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_SUCCESS:
			return {
				...state,
				fetchFixedDepositCollectionApproveDetailsResponse: action.payload,
			};

		case FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_FAILURE:
			return { ...state, fetchFixedDepositCollectionApproveDetailsResponse: action.payload };

		case FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchFixedDepositCollectionApproveDetailsResponse: null };
		/** *********************  END FETCH FIXED DEPOSIT COLLCTION APPROVE DETAILS  ******************** */

		/** *********************  START FETCH FIXED DEPOSIT COLLCTION APPROVE EOD DETAILS  ******************** */
		case FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_SUCCESS:
			return {
				...state,
				fetchFixedDepositCollectionApproveEodDetailsResponse: action.payload,
			};

		case FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_FAILURE:
			return {
				...state,
				fetchFixedDepositCollectionApproveEodDetailsResponse: action.payload,
			};

		case FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchFixedDepositCollectionApproveEodDetailsResponse: null };
		/** *********************  END FETCH FIXED DEPOSIT COLLCTION APPROVE EOD DETAILS  ******************** */
		default:
			return state;
	}
};
